/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '@store/mutations.constants';
import loginState from './state';

export const state = loginState;
const mutations = {
  [storeMutations.loginMutation]: (state, res) => {
    if (res.status === 200) {
      state.user = res.data;
      state.token = res.data.token;
      console.log(res.data, state.user);
      // state.role = res.data.user.role;
      // state.group = res.data.user.group;
      // LocalStorageService.setItem(appConstants.sessionKey, state.token);
      // SessionStorageService.setItem(appConstants.sessionKey, state.token);
      // LocalStorageService.setItem(appConstants.user, res.data.user);
      // SessionStorageService.setItem(appConstants.user, res.data.user);
    }
  },
  // [storeMutations.loginWithTokenMutation]: (state, res) => {
  //   console.log(res);
  //   state.user = state.result;
  //   state.token = state.user.token;
  //   LocalStorageService.setItem(appConstants.sessionKey, state.token);
  //   SessionStorageService.setItem(appConstants.sessionKey, state.token);
  // },
  [storeMutations.loginWithTokenMutation]: (state, res) => {
    state.user = res.data.user;
    state.token = res.data.user.token;
    state.role = res.data.user.role;
    state.group = res.data.user.group;
    // LocalStorageService.setItem(appConstants.sessionKey, state.token);
    // SessionStorageService.setItem(appConstants.sessionKey, state.token);
  },
  [storeMutations.setUserRolePermissions]: (state, res) => {
    if (res) {
      state.permissionsList = res.data.modules;
    }
  },
  [storeMutations.setUserNotifications]: (state, res) => {
    if (res) {
      state.notifications = res.data.filter((element) => {
        return !element.isDisableInPopUp;
      });
    }
  },
  [storeMutations.setUserLogout]: (state, res) => {
    state.isAuthenticated = false;
    state = {};
    localStorage.removeItem('vuex');
    localStorage.clear();
    sessionStorage.clear();
  },
  [storeMutations.setUserGroups]: (state, res) => {
    if (res) {
      state.groups = res.data;
    }
  },
  [storeMutations.setUserSelfDashboards]: (state, res) => {
    if (res) {
      state.selfDashboards = res.data;
    }
  },
  [storeMutations.setAdminUsers]: (state, res) => {
    if (res) {
      state.adminUsers = res.data;
    }
  },
  [storeMutations.setUserInvite]: (state, res) => {
    if (res) {
      state.message = res.data.message;
    }
  },
  [storeMutations.setForgotPassword]: (state, res) => {
    if (res) {
      state.result = res.data;
    }
  },
  [storeMutations.setProjectByUserId]: (state, res) => {
    if (res) {
      state.projectList = res.data;
    }
  },
  [storeMutations.setCreatedUserGroup]: (state, res) => {
    if (res) {
      state.message = res.data;
    }
  },
  [storeMutations.setUsersByGroupId]: (state, res) => {
    if (res) {
      state.groupUsers = res.data;
    }
  },
  [storeMutations.setUpdateUserGroup]: (state, res) => {
    if (res) {
      state.message = res.data.message;
    }
  },
  [storeMutations.setDeleteUserGroup]: (state, res) => {
    if (res) {
      state.message = res.data.message;
    }
  },
  [storeMutations.setGroupByUserId]: (state, res) => {
    if (res) {
      state.message = res.data;
    }
  },
  [storeMutations.setUpdateUser]: (state, res) => {
    if (res) {
      state.message = res.data;
    }
  },
  [storeMutations.setResetPassword]: (state, res) => {
    if (res) {
      state.result = res.data;
    }
  },
  [storeMutations.setUserByEmail]: (state, res) => {
    if (res) {
      state.result = res.data;
    }
  },
  [storeMutations.setUserUpdate]: (state, res) => {
    if (res) {
      state.message = res.data;
    }
  },
  [storeMutations.setUserById]: (state, res) => {
    if (res) {
      state.result = res.data;
    }
  },
  [storeMutations.setUsersByProjectId]: (state, res) => {
    if (res) {
      state.users = res.data;
    }
  },
  [storeMutations.setGroupById]: (state, res) => {
    if (res) {
      state.result = res.data;
    }
  },
  [storeMutations.setUserLogoutByName]: (state, res) => {
    if (res) {
      state.userLogOut = res;
    }
  },
  [storeMutations.setUserStore]: (state, res) => {
    state.user = res;
  },
  [storeMutations.setIsValidToken]: (state, res) => {
    state.result=res.data;
  },
  [storeMutations.setCurrentUser]:(state,res)=>{
    state.currentUser=res.data
  }
};
export default { ...mutations };
